import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-yes-no-cancel',
  templateUrl: './yes-no-cancel.component.html',
  styles: [
  ]
})
export class YesNoCancelComponent implements OnInit {

  title: string = null;
  prompt: string = 'Are you sure?';

  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirmModal(yesNo: boolean): void {
    this.modal.close(yesNo);
  }

  dismissModal(): void {
    this.modal.dismiss();
  }

}
